import { EventEmitter, Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { HttpService } from "../core/service/http.service";
import { HubConnection, HubConnectionBuilder } from "@microsoft/signalr";
import { environment } from "src/environments/environment";
import * as signalR from "@microsoft/signalr";
import { Prescription } from "../shared/models/prescription";
import { UserIdleService } from 'angular-user-idle';


@Injectable({
  providedIn: "root",
})
export default class PharmcistService {
  public pendingDoctorsCount = new BehaviorSubject<number>(0);
  constructor(private httpService: HttpService,
    private userIdle: UserIdleService
    ) {
      this.restart()
  }

  AddSIGCode(codeDetails: any): Observable<any> {
    return this.httpService.post("prescription/AddSIGCodes",codeDetails);
  }

  UpdateSIGCode(codeDetails: any): Observable<any> {
    return this.httpService.post("prescription/UpdateSIGCodes",codeDetails);
  }

  GetSIGCode(codeDetails: any): Observable<any> {
    return this.httpService.post("prescription/GetPrescriptionCode",codeDetails);
  }

  

  GetDashboardCount(pharmacyDetails: any): Observable<any> {
    return this.httpService.post(
      "pharmacyapi/GetPharmacistDashboardStat",
      pharmacyDetails
    );
  }

  ChangeDoctorStatus(doctorDetails: any): Observable<any> {
    return this.httpService.post(
      "pharmacyapi/ChangeDoctorStatus",
      doctorDetails
    );
  }

  DeactivateDoctor(accountDetails: any): Observable<any> {
    return this.httpService.post("account/Delete", accountDetails);
  }
  GetPharmacyDetails(pharmacyDetails: any): Observable<any> {
    return this.httpService.post("pharmacyapi/Get", pharmacyDetails);
  }
  GetPharmacyUsers(pharmacyDetails: any): Observable<any> {
    return this.httpService.post(
      "pharmacyapi/ListPharmacyUser",
      pharmacyDetails
    );
  }

  AddPharmacyUser(pharmacyDetails: any): Observable<any> {
    return this.httpService.post("account/Add", pharmacyDetails);
  }
  UpdatePharmacyUser(pharmacyDetails: any): Observable<any> {
    return this.httpService.post("account/Update", pharmacyDetails);
  }
  DeletePharmacyUser(pharmacyDetails: any): Observable<any> {
    return this.httpService.post("account/Delete", pharmacyDetails);
  }
  ResetPharmacyUser(pharmacyDetails: any): Observable<any> {
    return this.httpService.post("account/ResetPassword", pharmacyDetails);
  }
  UpdatePharmacy(pharmacyDetails: any): Observable<any> {
    return this.httpService.post("pharmacyapi/Update", pharmacyDetails);
  }
  GetDrugListByPrescriptionId(pharmacyDetails: any): Observable<any> {
    return this.httpService.post(
      "prescription/GetPrescriptionById",
      pharmacyDetails
    );
  }
  restart() {
    this.userIdle.resetTimer();
  }
}
